import type { PatchRequestType } from '@onhandtech/onhand-fe-shared/lib/api/v4/requests/post-patch-request-by-id/post-patch-request-by-id.types'
import type { PayloadAction } from '@reduxjs/toolkit'
import type { FormatMessageFunction } from 'contracts/locale/locale'

import selectedRequestSlice from './missions.slice'
import { moduleName } from './missions.types'

export const actionTypes = {
  CLOSE_SELECTED_REQUEST: `${moduleName}/CLOSE_SELECTED_REQUEST`,
  PATCH_SELECTED_REQUEST: `${moduleName}/PATCH_SELECTED_REQUEST`,
}

const closeSelectedRequest = (refreshRequests: boolean): PayloadAction<boolean> => ({
  type: actionTypes.CLOSE_SELECTED_REQUEST,
  payload: refreshRequests,
})

export type PatchSelectedRequestPayload = {
  patchRequestType: PatchRequestType
  requestId: string
  formatMessage: FormatMessageFunction
}

const patchSelectedRequest = (
  requestId: string,
  patchRequestType: PatchRequestType,
  formatMessage: FormatMessageFunction,
): PayloadAction<PatchSelectedRequestPayload> => ({
  type: actionTypes.PATCH_SELECTED_REQUEST,
  payload: {
    requestId,
    patchRequestType,
    formatMessage,
  },
})

const {
  clearBeneficiaryIndicator,
  clearSelectedRequest,
  setAutoEnroll,
  setMissionType,
  setNumberOfMissionsForRequestType,
  setOrderBy,
  setPatchRequestType,
  setSearchQuery,
  setSelectedRequest,
  setSelectedStatusOption,
  setShowRejectionScreen,
  updateDraftRequest,
} = selectedRequestSlice.actions

export {
  clearBeneficiaryIndicator,
  clearSelectedRequest,
  closeSelectedRequest,
  patchSelectedRequest,
  setAutoEnroll,
  setMissionType,
  setNumberOfMissionsForRequestType,
  setOrderBy,
  setPatchRequestType,
  setSearchQuery,
  setSelectedRequest,
  setSelectedStatusOption,
  setShowRejectionScreen,
  updateDraftRequest,
}
